import { openControlsModal } from '../../../State/controlsModal'

export default () => (dispatch) => {

  dispatch(openControlsModal())

}
